<template>
  <div ref="menuWrap" class="sync-language-menu">
    <v-menu
      v-model="menuOpen"
      :attach="$refs.menuWrap"
      content-class="sync-language-menu-dropdown"
      transition="slide-x-transition"
      min-width="19.25rem"
      allow-overflow
      offset-overflow
      offset-x
      nudge-right="5"
      top
      z-index="1000"
    >
      <template #activator="{ on, attrs }">
        <v-btn
          icon
          class="sync-language-menu-btn"
          :title="$t('language.changeLanguage')"
          :aria-label="$t('language.changeLanguage')"
          v-bind="attrs"
          v-on="on"
        >
          <v-icon size="24">mdi-web</v-icon>
        </v-btn>
      </template>

      <div class="sync-language-menu-content">
        <v-btn
          text
          tile
          elevation="0"
          class="sync-language-menu-item"
          @click="handleSelect('en')"
        >
          <v-img :src="flags.en" max-height="26" max-width="26" />
          <span>{{ $t('language.en') }}</span>
        </v-btn>

        <v-divider class="sync-language-menu-divider" />

        <v-btn
          text
          tile
          elevation="0"
          class="sync-language-menu-item"
          @click="handleSelect('br')"
        >
          <v-img :src="flags.br" max-height="26" max-width="26" />
          <span>{{ $t('language.pt') }}</span>
        </v-btn>

        <v-divider class="sync-language-menu-divider" />

        <v-btn
          text
          tile
          elevation="0"
          class="sync-language-menu-item"
          @click="handleSelect('es')"
        >
          <v-img :src="flags.es" max-height="26" max-width="26" />
          <span>{{ $t('language.es') }}</span>
        </v-btn>
      </div>
    </v-menu>
  </div>
</template>

<script>
import { calcLocaleToApiLanguage, setStoredLanguage } from '@/helpers/locale'
import { putAccountMe } from '@/services/account'

export default {
  name: 'LanguageMenu',

  data() {
    return {
      menuOpen: false,
      flags: {
        br: require('@/assets/images/languages/pt-BR.svg'),
        en: require('@/assets/images/languages/en-US.svg'),
        es: require('@/assets/images/languages/es-AR.svg'),
      },
    }
  },

  computed: {
    _currentLocale() {
      return this.$i18n.locale
    },
  },

  watch: {
    $route() {
      this.menuOpen = false
    },
  },

  methods: {
    async handleSelect(locale) {
      if (locale === this._currentLocale) return

      setStoredLanguage(locale)

      try {
        await putAccountMe({ language: calcLocaleToApiLanguage(locale) })
      } catch (e) {
        // best-effort persist — a troca local vale mesmo se a API falhar;
        // console.error (não console.log) deixa rastro no devtools/monitoring
        console.error(
          '[sync] putAccountMe falhou ao persistir idioma (best-effort)',
          e
        )
      }

      window.location.reload()
    },
  },
}
</script>

<style lang="scss" scoped>
.sync-language-menu {
  position: relative;
  display: flex;
  justify-content: center;
}

.sync-language-menu-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0.625rem 0;
  background-color: #ffffff;
}

.sync-language-menu-divider {
  width: calc(100% - 1.5rem);
}

.sync-language-menu-item {
  text-transform: none;
  letter-spacing: normal;
  font-size: 1rem;
  color: #2c3a4b !important;
  font-weight: 400;

  &.v-size--default {
    padding: 0 1rem !important;
    min-height: 2.8125rem;
    width: 100%;
  }

  ::v-deep .v-btn__content {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 1.75rem;
  }
}
</style>

<!-- Unscoped: wrapper do conteúdo do v-menu (content-class) é gerado pelo Vuetify -->
<style lang="scss">
.sync-language-menu-dropdown {
  border: 1px solid #dadee3;
  box-shadow: 0 0.125rem 0.625rem rgba(0, 0, 0, 0.08) !important;
}
</style>
